import { render, staticRenderFns } from "./StepsHeader.vue?vue&type=template&id=c5970ec0"
import script from "./StepsHeader.vue?vue&type=script&lang=ts"
export * from "./StepsHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports